module.exports = __webpack_public_path__ + "static/media/hair (18).69c3655d.jpg";